import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { COLORS, COLORS3, MEDIA_QUERY, SPACING, ZINDEX } from '@zola/zola-ui/src/styles/emotion';

import { MarketingModuleContainer } from 'pages/WebsiteDesignsPLPSSR/ThemeGroup/ThemeGroup.styles';
import {
  postAuthNav3ThemeGroupBorder,
  themeGroupBorder,
} from 'pages/WebsiteDesignsPLPV2/components/PLPThemeGroup/PLPThemeGroup.styles';
import { BreadcrumbsV2 } from '@zola/zola-ui/src/components/BreadcrumbsV2';
import { SegmentControl } from '@zola/zola-ui/src/components/SegmentControlV2/SegmentControlV2.styles';
import {
  PLPControlsBarContainer,
  ChipWrapper,
} from 'pages/WebsiteDesignsPLPV2/components/PLPControlsBar/PLPControlsBar.styles';
import { MobileBarContainer } from 'pages/WebsiteDesignsPLPV2/components/PLPMobileBar/PLPMobileBar.styles';
import { PillContainer } from 'pages/WebsiteDesignsPLPV2/components/PLPCurrentFilters/PLPCurrentFilters.styles';

import { FooterWrapper } from '@zola/zola-ui/src/components/PreAuthV3/PreauthFooterV3.styles';

export const hideWhenDesktop = css`
  ${MEDIA_QUERY.DESKTOP} {
    display: none;
  }
`;

export const hideWhenNotTablet = css`
  ${MEDIA_QUERY.MOBILE} {
    display: none;
  }
  ${MEDIA_QUERY.DESKTOP} {
    display: none;
  }
`;

export const hideWhenNotMobile = css`
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    display: none;
  }
`;

export const hideWhenTabletAndMobile = css`
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    display: none;
  }
`;

export const PaddedContainer = styled.div<{ isPostAuthNav3?: boolean }>`
  padding: 0 ${SPACING.LG} ${SPACING.S24} ${SPACING.LG};

  ${MEDIA_QUERY.MOBILE} {
    padding: 0 ${SPACING.MD} ${SPACING.S24} ${SPACING.MD};
  }

  ${MEDIA_QUERY.TABLET} {
    padding: 0 ${SPACING.MD} ${SPACING.S24} ${SPACING.MD};
  }

  ${MEDIA_QUERY.DESKTOP_MASSIVE} {
    max-width: 1920px;
    margin-left: auto;
    margin-right: auto;
    border-left: ${({ isPostAuthNav3 }) =>
      isPostAuthNav3 ? null : `1px solid ${COLORS3.BLACK_030}`};
    border-right: ${({ isPostAuthNav3 }) =>
      isPostAuthNav3 ? null : `1px solid ${COLORS3.BLACK_030}`};
  }
`;

export const ControlsContainer = styled.div<{
  isGuest: boolean;
  isPostAuthNav3?: boolean;
  stickyGridControls: boolean;
}>`
  ${({ isGuest, isPostAuthNav3, stickyGridControls }) => {
    let top = '68px';
    if (isGuest) {
      top = '76px';
    } else if (isPostAuthNav3) {
      top = '50px';
    }
    return (
      stickyGridControls &&
      css`
        background-color: ${COLORS.WHITE};
        border-bottom: ${isPostAuthNav3 ? postAuthNav3ThemeGroupBorder : themeGroupBorder};
        left: 0;
        position: fixed; // could not rely on position: sticky. we have an overflow style on body element that couldn't be removed + the dynamic nav throws positioning off
        right: 0;
        top: ${top}; // height of nav when scrolled
        width: 100%;
        z-index: ${ZINDEX.top};
        padding: ${SPACING.XS} ${SPACING.LG};

        ${PLPControlsBarContainer}, ${MobileBarContainer}, ${PillContainer} {
          padding: ${isPostAuthNav3 ? '0 0 0 74px' : 0};
        }

        ${ChipWrapper} {
          margin-bottom: 0;
        }

        ${MEDIA_QUERY.TABLET} {
          padding: ${SPACING.XS} ${SPACING.MD};
          top: 60px; // height of mobile nav when scrolled
        }

        ${MEDIA_QUERY.MOBILE} {
          padding: ${SPACING.XS} ${SPACING.MD};
          top: 60px; // height of mobile nav when scrolled
        }

        ${MEDIA_QUERY.DESKTOP_MASSIVE} {
          max-width: ${isPostAuthNav3 ? '1919px' : null};
        }
      `
    );
  }}

  ${SegmentControl} {
    margin-bottom: 0;
  }
`;

export const Page = styled.div`
  background-color: ${COLORS.WHITE};
  ${FooterWrapper} {
    // Pre auth footer
    margin-left: auto;
    margin-right: auto;
    border-top: none;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: -1px;
      right: 0;
      left: 0;
      border-top: 1px solid ${COLORS3.BLACK_030};
    }

    ${MEDIA_QUERY.DESKTOP_MASSIVE} {
      max-width: 1920px;
      border-left: 1px solid ${COLORS3.BLACK_030};
      border-right: 1px solid ${COLORS3.BLACK_030};
    }
  }

  footer.zola-ui.common-footer {
    // old footer is not in emotion, so using a selector
    border-top: none;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: -1px;
      right: 0;
      left: 0;
      border-top: 1px solid ${COLORS3.BLACK_030};
    }
  }
`;

export const StyledBreadcrumbs = styled(BreadcrumbsV2)`
  padding: ${SPACING.S16} 0 0 0;
  margin: 0;
`;

export const V1MarketingModuleContainer = styled.div`
  align-items: center;
  border-bottom: ${themeGroupBorder};
  border-right: ${themeGroupBorder};
  display: flex;
  flex-flow: column;
  justify-content: center;
  max-width: 100%;
  padding: ${SPACING.S16} ${SPACING.S16} ${SPACING.S32} ${SPACING.S16};
  width: 100%;

  ${MarketingModuleContainer} {
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;

export const PLPContentWrapper = styled.div<{
  isPostAuthNav3?: boolean;
}>`
  ${MEDIA_QUERY.DESKTOP} {
    margin-left: ${props => (props.isPostAuthNav3 ? '74px' : '0')};
  }
`;
